const animatedScrollObserver = new IntersectionObserver((entries, animatedScrollObserver) => {
    entries.forEach((entry) => {
        if (entry.isIntersecting) {
            entry.target.classList.add('enter');
            animatedScrollObserver.unobserve(entry.target)
        }
    })
})
export default {
    bind(el) {
        el.classList.forEach( value => {
            if (value === 'right') {
                el.classList.add('before-enter-right');
            } else if (value === 'left') {
                el.classList.add('before-enter-left');
            } else {
                el.classList.add('before-enter');
            }
        })
        if (el.classList.length === 0)  el.classList.add('before-enter');
        animatedScrollObserver.observe(el);
    }
}